import { Link } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { LuMessageCircle } from 'react-icons/lu';

import { ChatEntryDisabledTooltip } from '~/features/whatsapp/components/ChatEntryDisabledTooltip';
import { useChatEntryState } from '~/features/whatsapp/hooks/useChatEntryState';
import { CHAT_ENTRY_STATES } from '~/features/whatsapp/utils/resolveChatEntryState';

export const Communication = () => {
    const { t } = useTranslation();
    const chatEntryState = useChatEntryState();

    const content = (
        <>
            <LuMessageCircle />
            <span>{t('TOP_HEADER.NAV_BAR.COMMUNICATION')}</span>
        </>
    );

    if (chatEntryState === CHAT_ENTRY_STATES.HIDDEN || chatEntryState === CHAT_ENTRY_STATES.LOADING) return null;

    if (chatEntryState !== CHAT_ENTRY_STATES.ENABLED)
        return (
            <ChatEntryDisabledTooltip state={chatEntryState}>
                <span
                    aria-disabled="true"
                    className="flex items-center px-2 py-1 gap-2 text-sm rounded text-white opacity-50 cursor-not-allowed"
                    data-testid="communication-nav-disabled"
                >
                    {content}
                </span>
            </ChatEntryDisabledTooltip>
        );

    return (
        <Link
            to="/communication"
            className="flex items-center px-2 py-1 gap-2 text-sm rounded transition-all"
            inactiveProps={{ className: 'text-white hover:bg-white hover:text-[#1e2b43]' }}
            activeProps={{ className: 'bg-white text-[#1e2b43]' }}
        >
            {content}
        </Link>
    );
};
